module.exports = __webpack_public_path__ + "static/media/Noor.80ca3b57.svg";